if ($('body').is('.template-product')) {

  const allDetails = $('.collapsible-tabs__block details');

  // Hide all content initially
  allDetails.find('.collapsible-content').hide();

  // Onload — open first accordion smoothly
  const first = $('.collapsible-tabs__block:first details');
  first.addClass('is-open').attr('open', true);
  first.find('.collapsible-content').slideDown(300);

  // Click handler
  $('.collapsible-tabs__block details summary').on('click', function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const currentDetails = $(this).parent();
    const content = currentDetails.find('.collapsible-content');

    // If clicked accordion is already open → close it
    if (currentDetails.hasClass('is-open')) {
      currentDetails.removeAttr('open').removeClass('is-open');
      content.stop(true, true).slideUp(300);
      return;
    }

    // Close all others
    allDetails.not(currentDetails).each(function() {
      $(this).removeAttr('open').removeClass('is-open')
        .find('.collapsible-content').stop(true, true).slideUp(300);
    });

    // Open the clicked one
    currentDetails.attr('open', true).addClass('is-open');
    content.stop(true, true).slideDown(300);
  });


  // scroll s mooth
$('a[href^="#"]').on('click', function(e) {
    e.preventDefault();

    var target = $($(this).attr('href'));
    if (target.length) {
        var headerHeight = $('.header').outerHeight() || 0;

        // Desktop vs Mobile offset
        var extraOffset = window.innerWidth <= 768 ? -35 : 50; 
        // 👆 Mobile (≤768px) ke liye zyada upar scroll karega

        var scrollTo = target.offset().top - headerHeight - extraOffset;

        $('html, body').animate({
            scrollTop: scrollTo
        }, 600);
    }
});


setTimeout(function() {

$('.owl-item.active:first img').trigger('click');
}, 600);
}
